import { render, staticRenderFns } from "./template-list.vue.js?vue&type=template&id=4c73d68e!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./template-list.vue?vue&type=template&id=4c73d68e"
import script from "./template-list.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./template-list.vue?vue&type=script&setup=true&lang=js"
export * from "./template-list.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./template-list.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports